import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {}

  share (event) {
    event.preventDefault()

    let text = this.element.dataset.shareText
    let url = window.location.href
    let href = `https://twitter.com/share?text=${text}&url=${url}`

    window.open(href, '_blank')

    if (typeof window.posthog !== 'undefined') {
      window.posthog.capture('shared_content', {
        share_method: 'twitter',
        source: window.location.pathname
      })
    }
  }
}
